import bidderMeta from '@/router/bidder/bidderMeta.js'

export default [
  {
    path: '/bidder/trade/active',
    name: 'bidder-trade-active',
    meta: {
      ...bidderMeta,
      layout: 'main-sidebar-layout',
    },
    component: () => import('@/views/Bidder/Trade/BidderSidebarTradeActiveView.vue'),
  },
  {
    path: '/bidder/trade/my-applications',
    name: 'bidder-trade-my-applications',
    meta: {
      ...bidderMeta,
      layout: 'main-sidebar-layout',
    },
    component: () => import('@/views/Bidder/Trade/BidderSidebarTradeMyApplicationsView.vue'),
  },
  {
    path: '/bidder/trade/archive',
    name: 'bidder-trade-archive',
    meta: {
      ...bidderMeta,
      layout: 'main-sidebar-layout',
    },
    component: () => import('@/views/Bidder/Trade/BidderSidebarTradeArchiveView.vue'),
  },
]
